export default __webpack_public_path__ + "04d06b4fbffa44e5b9f5fd87554b509b.png";